// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Bjda","load2":"Spinner_load2__2jTMH"};